import { useId } from 'react';
import { RENDER_PRESETS, resolveRenderPreset, type RenderPresetId } from '../../domain/render-preset';

const RATIOS: Record<RenderPresetId, string> = {
  'landscape-16x9': '16:9', 'social-4x5': '4:5', 'vertical-9x16': '9:16',
};

/** Global output format; uses the same saved preset and export contract as Studio. */
export function AspectRatioControl({ value, onChange, compact = false, disabled = false }: {
  value: RenderPresetId; onChange: (value: RenderPresetId) => void; compact?: boolean; disabled?: boolean;
}) {
  const help = useId(), output = resolveRenderPreset(value);
  return <label className={compact ? 'studio-aspect-ratio' : 'studio-select-row'}>
    <span>Aspect ratio</span><select aria-label="Aspect ratio" aria-describedby={help} title={`${output.width} × ${output.height} output`}
      value={value} disabled={disabled} onChange={event => onChange(event.target.value as RenderPresetId)}>
      {RENDER_PRESETS.map(preset => <option key={preset.id} value={preset.id}>
        {compact ? RATIOS[preset.id] : `${RATIOS[preset.id]} · ${preset.width} × ${preset.height}`}
      </option>)}
    </select><span id={help} className="sr-only">Output size: {output.width} by {output.height} pixels.</span>
  </label>;
}
